import ecbrApi from '../services/ecbrApi'
import { removeRedundantOptions } from './removeRedundantOptions'

export const loadBrandOptions = async (inputValue) => {
  const { data } = await ecbrApi.brands.getAllActualCompanyBrands({
    brandName: inputValue
  })
  const brands = data?.map(({ id, brandName }) => ({
    value: id,
    label: brandName
  }))
  return removeRedundantOptions(brands)
}

export const loadCertificateOptions = (brandId) => async (inputValue) => {
  const { data } = await ecbrApi.certificates.getAllBrandCertificates(brandId, {
    productName: inputValue
  })
  const certificates = data?.map((cert) => ({
    value: cert.id,
    label: cert.product.name
  }))
  return removeRedundantOptions(certificates)
}

export const loadPillarOptions = (certificateId) => async (inputValue) => {
  const { data } = await ecbrApi.pillars.getAllCertificatePillars(
    certificateId,
    { pillarName: inputValue }
  )
  const pillars = data?.map((cert) => ({
    value: cert.pillar.id,
    label: cert.pillar.name,
    ownerId: cert.ownerUserId
  }))
  return removeRedundantOptions(pillars)
}

export const adminLoadBrandOptions = (companyId) => async (inputValue) => {
  const { data } = await ecbrApi.brands.getAll({
    ...(companyId && { companyId }),
    ...(inputValue && { name: inputValue }),
    page: 1,
    take: 50
  })
  const brands = data.data.map(({ id, brandName }) => ({
    value: id,
    label: brandName
  }))
  return removeRedundantOptions(brands)
}

export const adminLoadCertificateOptions = (brandId) => async (inputValue) => {
  const { data } = await ecbrApi.certificates.getAll({
    ...(brandId && { brandId }),
    ...(inputValue && { productName: inputValue }),
    page: 1,
    take: 50
  })
  const certificates = data.data?.map((cert) => ({
    value: cert.id,
    label: cert.product.name
  }))
  return removeRedundantOptions(certificates)
}

export const adminLoadPillarOptions = (certificateId) => async (inputValue) => {
  const { data } = await ecbrApi.pillars.getUserCertificatePillars(
    certificateId,
    {
      ...(inputValue && { pillarName: inputValue }),
      page: 1,
      take: 50
    }
  )
  const pillars = data.data?.map((cert) => ({
    value: cert.pillar.id,
    label: cert.pillar.name
  }))
  return removeRedundantOptions(pillars)
}
